export class PersonEntity {
  public administrator = false;
  public familyName: string = null;
  public firstName: string = null;
  public historicalNameEditor = false;
  public nameEditor = false;
  public passwordEdit: string = null;
  public personId: number = null;
  public personType: 'EXTERNAL' = 'EXTERNAL';
  public reportObserver = false;
  public userName: string = null;
  public authId: string = null;

  static newPerson() {
    return new PersonEntity();
  }
}
